import { FC } from 'react';

import { Image } from '@phoenix/team-m/dashboard/frontend/shared/components/image';
import { containerQueries } from '@phoenix/design-system/frontend/ui/breakpoints/breakpoints';

export const ProductImage: FC<{ src: string; alt: string }> = ({ src, alt }) => (
  <div className="relative aspect-[4/3] w-full">
    <Image
      src={src}
      alt={alt}
      fill
      className="object-contain"
      sizes={`(max-width: ${containerQueries.tablet}) 80vw, (max-width: ${containerQueries.desktop}) 50vw, 20vw`}
    />
  </div>
);
